import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component EstimatePlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <EstimatePlusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <EstimatePlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EstimatePlusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="EstimatePlusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10q0 .507-.05 1.001L20 13v-1a8 8 0 1 0-8 8h1l.001 1.95Q12.506 22 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m7 12v3h3v2h-3v3h-2v-3.001L14 19v-2l3-.001V14zm-7-8a6 6 0 0 1 6 6h-2a4 4 0 1 0-4 4v2a6 6 0 0 1 0-12m0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
        clipRule="evenodd"
      />
    </svg>
  )
);
EstimatePlusIcon.displayName = "EstimatePlusIcon";
export default EstimatePlusIcon;
